/**
 * Best-effort navigation toward camera/microphone controls for the current browser.
 * Web pages cannot open chrome:// URLs or iOS Settings; Android may honor an app-details intent.
 */
export function openBrowserMediaSettings() {
  if (typeof window === 'undefined') return;

  const ua = navigator.userAgent || '';
  const isAndroid = /Android/i.test(ua);
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (typeof navigator !== 'undefined' &&
      navigator.platform === 'MacIntel' &&
      navigator.maxTouchPoints > 1);

  if (isAndroid) {
    let pkg = 'com.android.chrome';
    if (/EdgA/i.test(ua)) pkg = 'com.microsoft.emmx';
    else if (/Firefox/i.test(ua)) pkg = 'org.mozilla.firefox';
    else if (/SamsungBrowser/i.test(ua)) pkg = 'com.sec.android.app.sbrowser';

    const dataUri = encodeURIComponent(`package:${pkg}`);
    const fallback = encodeURIComponent(
      'https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DAndroid'
    );
    window.location.href = `intent:#Intent;action=android.settings.APPLICATION_DETAILS_SETTINGS;data=${dataUri};S.browser_fallback_url=${fallback};end`;
    return;
  }

  if (isIOS) {
    window.open(
      'https://support.apple.com/guide/iphone/change-safari-settings-iphb3100d149/ios',
      '_blank',
      'noopener,noreferrer'
    );
    return;
  }

  const isSafari =
    /^((?!chrome|android).)*safari/i.test(ua) || /Version\/[\d.]+.*Safari/.test(ua);
  if (isSafari && !/Chrome|Chromium|Edg/.test(ua)) {
    window.open(
      'https://support.apple.com/guide/mac-help/control-access-to-the-camera-mchlp2980/mac',
      '_blank',
      'noopener,noreferrer'
    );
    return;
  }

  window.open(
    'https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DDesktop',
    '_blank',
    'noopener,noreferrer'
  );
}
